import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f6d353"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-message-solid",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("消息")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("通知")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("库存预警")
const _hoisted_5 = {
  key: 0,
  class: "box"
}
const _hoisted_6 = { class: "notification_text" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { style: {"font-size":"12px","color":"#ccc"} }
const _hoisted_11 = {
  key: 1,
  class: "box"
}
const _hoisted_12 = { class: "recive_text" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "recivetext" }
const _hoisted_15 = { class: "reciveClass" }
const _hoisted_16 = {
  key: 2,
  class: "box"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("一键已读")

import { ref, computed, onMounted, onUnmounted } from "vue";
import { getObList, receivelist, getUpdaterecive, getUpdate, getStockWarningMessage } from '@/service/main/dashboard'
import { useStore } from "@/store";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const userName = computed(() => store.state.login.userInfo.account)
// 左侧消息变更数据条数
const mesCount = ref(0)
// 右侧消息变更数据条数
const noticeCount = ref(0)
const stockCount = ref(0)
// 默认展示
const activeIndex = ref('1')
const currentCount = ref("1")
const leftListData = ref([])
const stockListData = ref([])
const handleSelect = (key: string, keyPath: string[]) => {
  currentCount.value = key
}
const getMessData = () => {
  getObList().then((res:any) => {
    if(res.code==200){
      const { data } = res
      leftListData.value = data.list
      mesCount.value = data.count
    }   
  })
}
// 通知变更数据
const rightListData: any = ref([])
const getReceiveData = () => {
  rightListData.value = []
  receivelist().then((res:any) => {
    if(res.code==200){
      const { data } = res
    if(data==null){
      return
    }
    data.messages.forEach((item: any, index: number) => {
      rightListData.value.push({
        id: item.split(",")[0],
        deliveryNo: item.split(",")[1]
      })
    })
    noticeCount.value = data.count
    }
  })
}
const getThirdWaringData = () => {
	stockListData.value = []
	getStockWarningMessage().then((res:any)=>{
		if(res.code==200) {
			stockListData.value = res.data.messages || []
		}
	}).catch(err=>{
		console.log(err)
	}).finally(()=>{
		stockCount.value = stockListData.value.length
	})
}
const msgclick = (row: any) => {
  // console.log(row)
  const obj = {
    idList: [row.id]
  }
  if (userName.value.toLowerCase() == 'superadmin' || userName.value.toLowerCase() == 'admin') {
    getUpdate(obj).then((res) => {

      getMessData()
      router.push('/supplierManagement/supplierAppointmentManagement')
    })
  } else {
    getUpdate(obj).then((res) => {
      getMessData()
      router.push('/supplier/deliveryAppointment')
    })

  }
}
const reviveclick = (row: any) => {
  // console.log(row)
  const obj = {
    idList: [row.id]
  }
  if (userName.value.toLowerCase() == 'superadmin' || userName.value.toLowerCase() == 'admin') {
    getUpdaterecive(obj).then((res) => {

      getReceiveData()
      router.push('/statistical/receivingRecord')
    })
  } else {
    getUpdaterecive(obj).then((res) => {
      getReceiveData()
      router.push('/supplier/receiving')
    })

  }
}

const stockWarningclick = function(row: any){
	router.push('/statistical/inventoryList')
}
const arraylist = ref([])
const Read = () => {
  if(currentCount.value=='1'){
    leftListData.value.forEach((item:any)=>{
      arraylist.value.push(item.id)
    })
    const obj = {
      idList: arraylist.value
    }
    if (userName.value.toLowerCase() == 'superadmin' || userName.value.toLowerCase() == 'admin') {
      getUpdate(obj).then((res) => {

        getMessData()
        router.push('/supplierManagement/supplierAppointmentManagement')
        arraylist.value = []
      })
    } else {
      getUpdate(obj).then((res) => {
        getMessData()
        router.push('/supplier/deliveryAppointment')
        arraylist.value = []
      })
    }
  }else{
    rightListData.value.forEach((item:any)=>{
      arraylist.value.push(item.id)
    })
    const obj = {
        idList: arraylist.value     
    }
    if (userName.value.toLowerCase() == 'superadmin' || userName.value.toLowerCase() == 'admin') {
      getUpdaterecive(obj).then((res) => {
        getReceiveData()
        router.push('/statistical/receivingRecord')
        arraylist.value = []
      })
    } else {
      getUpdaterecive(obj).then((res) => {
        getReceiveData()
        router.push('/supplier/receiving')
        arraylist.value = []
      })
    }
  }  
}
// 定时器
let timeInter: any = null
onMounted(() => {
	getMessData()
	getReceiveData()
	getThirdWaringData()
  timeInter = setInterval(() => {
    getMessData()
    getReceiveData()
		getThirdWaringData()
  }, 300000)
})
onUnmounted(() => {
  clearInterval(timeInter) //销毁
  timeInter = null
}) 

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "bottom",
    width: "",
    class: "bodycss",
    trigger: "click",
    teleported: false,
    "popper-append-to-body": false,
    "append-to-body": false
  }, {
    reference: _withCtx(() => [
      _createVNode(_component_el_badge, {
        "is-dot": mesCount.value !== 0 || noticeCount.value !== 0,
        class: "items"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["is-dot"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "1" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _withDirectives(_createVNode(_component_el_badge, {
                class: "mark",
                value: mesCount.value
              }, null, 8, ["value"]), [
                [_vShow, mesCount.value !== 0]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "2" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _withDirectives(_createVNode(_component_el_badge, {
                class: "mark",
                value: noticeCount.value
              }, null, 8, ["value"]), [
                [_vShow, noticeCount.value !== 0]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "3" }, {
            default: _withCtx(() => [
              _hoisted_4,
              _withDirectives(_createVNode(_component_el_badge, {
                class: "mark",
                "is-dot": true
              }, null, 512), [
                [_vShow, stockCount.value !== 0]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"]),
      (currentCount.value === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              data: leftListData.value,
              border: "",
              "show-header": false,
              style: {"width":"100%","margin-top":"10px"},
              "empty-text": "暂无数据"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { width: "330px" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (msgclick(scope.row))
                      }, [
                        _createElementVNode("img", {
                          src: scope.row.images ? scope.row.images : 'favicon.jpg',
                          class: "left_image"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", null, " 你有一条项目号" + _toDisplayString(scope.row.projectCode), 1),
                          _createElementVNode("p", _hoisted_10, "送货单号" + _toDisplayString(scope.row.remarks), 1)
                        ])
                      ], 8, _hoisted_7)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      (currentCount.value === '2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_el_table, {
              data: rightListData.value,
              border: "",
              "show-header": false,
              style: {"width":"100%","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { width: "330px" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (reviveclick(scope.row))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", _hoisted_15, "送货单号" + _toDisplayString(scope.row.deliveryNo) + "质检完成", 1)
                        ])
                      ], 8, _hoisted_13)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      (currentCount.value === '3')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockListData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"border-bottom":"1px dashed gray","padding":"10px 0"},
                key: index
              }, [
                _createElementVNode("div", {
                  onClick: _withModifiers(($event: any) => (stockWarningclick(item)), ["stop"])
                }, _toDisplayString(item), 9, _hoisted_17)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (mesCount.value !== 0 || noticeCount.value !== 0)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            disabled: currentCount.value === '3',
            type: "primary",
            onClick: Read
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})